
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Livello_1","data-name":"Livello 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M432.14 441.89H67.86V58.11h364.28zm-356.32-8h348.36V66.07H75.82z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M378.44 218.61a3.57 3.57 0 00-3.1-5.37H342V142a3.58 3.58 0 00-3.58-3.59H157.49a3.58 3.58 0 00-3.58 3.59v71.2h-29.25a3.58 3.58 0 00-3.59 3.59V358a3.58 3.58 0 003.59 3.59h250.68a3.57 3.57 0 003.1-5.36zm-250.2 5.68l81.13 70.88-81.13 56.28zm88.07 74.79h67l80.49 55.31H136.6zm73.95-3.92l81-70.76v126.41zm74.66-74.75l-23 20.07v-20.07zm-30.14-74.79v98.9a3.51 3.51 0 00.5 1.79l-52.19 45.6h-66.55l-55.46-48.46v-97.83zm-180.87 91.56l-19.2-16.77h19.2z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M186.33 169.52h123.2a3.59 3.59 0 100-7.17h-123.2a3.59 3.59 0 000 7.17zM234.41 181.88a3.59 3.59 0 000 7.18h75.12a3.59 3.59 0 100-7.18zM186.33 189.06h26.15a3.59 3.59 0 000-7.18h-26.15a3.59 3.59 0 000 7.18zM186.33 208.59h123.2a3.59 3.59 0 100-7.17h-123.2a3.59 3.59 0 000 7.17zM309.53 221H290.3a3.59 3.59 0 100 7.17h19.23a3.59 3.59 0 100-7.17zM186.33 228.12H269a3.59 3.59 0 100-7.17h-82.67a3.59 3.59 0 000 7.17zM299.92 240.48H196a3.59 3.59 0 000 7.17h104a3.59 3.59 0 100-7.17z"}})])
          )
        }
      }
    